<template>
  <Dialog @update:open="reset">
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>
    <DialogContent to="#notification-dialogs" class="w-[270px] rounded-lg">
      <DialogHeader>
        <VisuallyHidden>
          <DialogTitle>Masquage définitif</DialogTitle>
          <DialogDescription>Masquage définitif</DialogDescription>
        </VisuallyHidden>
      </DialogHeader>
      <div>
        <Input v-model="state.reason" type="text" placeholder="Une raison à préciser ?" />
      </div>
      <DialogFooter>
        <DialogClose as-child>
          <Button type="submit" class="bg-primary text-white" @click="submit">
            <Icon name="mdi-check" class="text-white" />
            Masquer définitivement
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script lang="ts" setup>
import {reactive} from 'vue';
import Icon from "@/core/components/icon/Icon.vue";
import {Button} from "@/core/components/ui/button";
import {Input} from "@/core/components/ui/input";
import {
    Dialog,
    DialogTrigger,
    DialogHeader,
    DialogContent,
    DialogTitle,
    DialogDescription, DialogFooter, DialogClose
} from "@/core/components/ui/dialog";
import {VisuallyHidden} from "reka-ui";
import {useNotificationStore} from "@/stores/notification.store";

const emit = defineEmits(['submit']);

const store = useNotificationStore();

const state = reactive({
    reason: '' as string,
});

/**
 * Submit the user input.
 */
const submit = () => {
    emit('submit', state.reason);
};

/**
 * Reset the user input.
 */
const reset = (openState: boolean) => {
    state.reason = '';
    store.modalOpen = openState;
};
</script>
